<template>
    <div id="AlertConfigDetail">
        <HrrBreadcrumb PMname="报警功能" CMname="报警配置管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="form" ref="form" :rules="rules" label-width="166px" class="el-form-module-config" :hide-required-asterisk="isView">
                    <el-form-item label="报警名称：" prop="alertName">
                        <!-- <el-input v-model="form.alertName" v-if="isAdd||isEdit"></el-input> -->
                        <el-select v-model="form.alertName" placeholder="请选择" v-if="isAdd||isEdit" @change="alertNameChange">
                            <el-option label="电流报警" value="电流报警"></el-option>
                            <el-option label="离线报警" value="离线报警"></el-option>
                            <el-option label="上线报警" value="上线报警"></el-option>
                            <el-option label="亮度报警" value="亮度报警"></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.alertName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="类型：" prop="alertType">
                        <el-select v-model="form.alertType" placeholder="请选择" v-if="isAdd||isEdit">
                            <el-option label="Email" value="Email"></el-option>
                            <el-option label="短信" value="短信"></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.alertType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="流路：" prop="mTypeCode" v-show="isElectricAlert">
                        <el-select v-model="form.mtypeCode" placeholder="请选择" v-if="isAdd||isEdit" >
                                <el-option v-for="item in mTypeData" :key="item.mtypeCode" :label="item.mtypeName" :value="item.mtypeCode" :hidden="item.disabled">
                                </el-option>
                            </el-select>
                        </el-select>
                        <span v-if="isView">
                            {{form.mtypeName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="条件：" prop="alertCondition" v-show="isElectricAlert">
                        <el-select v-model="form.alertCondition" placeholder="请选择" v-if="isAdd||isEdit" :disabled="isView">
                            <el-option label="大于" value=">"></el-option>
                            <el-option label="大于等于" value=">="></el-option>
                            <el-option label="小于" value="<"></el-option>
                            <el-option label="小于等于" value="<="></el-option>
                            <el-option label="等于" value="=="></el-option>
                            <el-option label="不等于" value="!="></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{form.alertCondition}}
                        </span>
                    </el-form-item>
                    <el-form-item label="条件值：" prop="alertValue" v-show="isElectricAlert">
                        <el-input-number v-model="form.alertValue" controls-position="right" :step="0.1"  :min="0" v-if="isAdd||isEdit"></el-input-number><!-- @change="handleChange" -->
                        <span v-if="isView">
                            {{form.alertValue}}
                        </span>
                    </el-form-item>
                    <el-form-item label="值类型：" prop="valueType" v-show="isElectricAlert">
                        <el-select v-model="form.valueType" placeholder="请选择" v-if="isAdd||isEdit" :disabled="isView">
                            <el-option label="百分比" value="百分比" :hidden="isPercentage"></el-option>
                            <el-option label="衡定值" value="衡定值" :hidden="isConstant"></el-option>    
                            <!-- <el-option label="叠加值" value="叠加值"></el-option>  暂时隐藏这个属性20230214-->
                        </el-select>
                        <span v-if="isView">
                            {{form.valueType}}
                        </span>
                    </el-form-item>
                    <el-form-item label="多久无数据报警(分钟)：" prop="howLongWithoutData" v-show="isNoElectricAlert">
                        <el-input-number v-model="form.howLongWithoutData" controls-position="right" :step="1" :min="0" v-if="isAdd||isEdit" @blur="inputFnc"></el-input-number>
                        <label style="padding:5px;color: #696969;" v-show="isLabel">请输入整数！</label>
                        <span v-if="isView">
                            {{form.howLongWithoutData}}
                        </span>
                    </el-form-item>
                     <el-form-item label="多久有数据报警(分钟)：" prop="howLongHaveData" v-show="isNoElectricAlert">
                        <el-input-number v-model="form.howLongHaveData" controls-position="right" :step="1" :min="0" v-if="isAdd||isEdit" @blur="inputFnc"></el-input-number>
                        <label style="padding:5px;color: #696969;" v-show="isLabel">请输入整数！</label>
                        <span v-if="isView">
                            {{form.howLongHaveData}}
                        </span>
                    </el-form-item>
                    <el-form-item label="模板标题：" prop="sendTitle">
                        <el-input v-model="form.sendTitle" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{form.sendTitle}}
                        </span>
                    </el-form-item>
                    <el-form-item label="模板内容：" prop="sendTemplate">
                        <el-input v-model="form.sendTemplate" v-if="isAdd||isEdit" type="textarea" :rows="8"></el-input>
                        <span v-if="isView">
                            {{form.sendTemplate}}
                        </span>
                    </el-form-item>
                    <el-form-item :label="this.howLongAlertCreateName"  prop="howLongAlertCreate">
                        <el-input-number v-model="form.howLongAlertCreate" controls-position="right" :step="1" :min="3" v-if="isAdd||isEdit" @blur="inputFnc"></el-input-number>
                        <label style="padding:5px;color: #696969;" v-show="isLabel">请输入整数！</label>
                        <span v-if="isView">
                            {{form.howLongAlertCreate}}
                        </span>
                    </el-form-item>
                    <el-form-item :label="'每天限发几次'+form.alertType+'：'" prop="oneDayHowNumSend">
                        <el-input-number v-model="form.oneDayHowNumSend" controls-position="right" :step="1" :min="0" v-if="isAdd||isEdit" @blur="inputFnc"></el-input-number>
                        <label style="padding:5px;color: #696969;" v-show="isLabel">请输入整数！零为不限制</label>
                        <!--<el-alert title="零为不限制，请输入整数" show-icon type="warning" :closable="false" v-if="isAdd||isEdit"></el-alert>-->
                        <span v-if="isView">
                            {{form.oneDayHowNumSend}}
                        </span>
                    </el-form-item>
                    <el-form-item label="状态：" prop="status">
                        <el-radio-group v-model="form.status">
                            <el-radio :label="1" :disabled="isView">启用</el-radio>
                            <el-radio :label="0" :disabled="isView">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('form')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('form')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'lightboxdetail',
    data() {
        return {
            form: {
                aConfigId: 0,
                alertName: "电流报警",
                alertType: "",
                mtypeCode: "",
                alertCondition: "",
                alertValue: "",
                howLongWithoutData:0,
                howLongHaveData:0,
                sendTemplate: "",
                sendTitle: "",
                howLongAlertCreate:3,
                oneDayHowNumSend:0,
                status: 1,
                valueType:"",
                howLongAlertCreateName:"",
            },
            rules: {
                alertName: [{ required: true, message: '请输入报警名称', trigger: 'blur' }],
                //alertCondition: [{ required: true, message: '请输入条件', trigger: 'change' }],
                //alertValue: [{ required: true, message: '请输入条件值', trigger: 'blur' }],
                sendTemplate: [{ required: true, message: '请输入内容', trigger: 'blur' }],
                sendTitle: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                alertType: [{ required: true, message: '请输入报警类型', trigger: 'change' }],
                // mTypeCode: [{ required: true, message: '请输入流路类型', trigger: 'change' }],
            },
            title: "",
            isEdit: true,
            isAdd: false,
            isView: false,
            isElectricAlert:true,
            isNoElectricAlert:false,
            isLabel:true,
            mTypeData:[],
            returnPath: "",
            isPercentage:false,
            isConstant:false,
        }
    },
    methods: {
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.isAdd ? this.$api.AlertConfig.api : this.$api.AlertConfig.api + "/" + this.form.aConfigId;
                    this.form.alertName=="离线报警"||this.form.alertName=="上线报警" ?this.form.alertValue=null :"";
                    this.form.alertName=="电流报警"||this.form.alertName=="亮度报警"?(this.form.howLongWithoutData=null,this.form.howLongHaveData=null):"";
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.form
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: Vuethis.returnPath });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        alertNameChange: function(v) {
            if(v=="离线报警"||v=="上线报警"){
                this.isElectricAlert=false;
                this.isNoElectricAlert=true;
                this.form.mtypeCode="T01";
                this.form.alertValue="";
            }else{
                this.isElectricAlert=true;
                this.isNoElectricAlert=false;
                this.form.mtypeCode="";
                this.form.mtypeName="";
                //this.form.mtypeCode="";
            }
            this.initAlertName(v);
            
        },
        /*
         <summary>
         初始化流路选择器，选择电流报警时只显示电流类型，离线/上线报警只显示异常类型，亮度报警显示除上述类型的其他类型，20230214
         </summary>
         <param name="v">流路类型名</param>
         <returns></returns>
        */
        initAlertName:function(v){
            if(v=="电流报警"){
                this.mTypeData.forEach(m=>{
                    if(m.mtypeName!="电流"){
                        m.disabled=true;
                    }else{
                       m.disabled=false;
                    }
                });
                 
                this.isConstant=true;
                this.isPercentage=false;
                this.howLongAlertCreateName="连续触发多久报警:";
            }else if(v=="离线报警"||v=="上线报警"){
                this.mTypeData.forEach(m=>{
                    if(m.mtypeName!="异常"){
                        m.disabled=true;
                    }else{
                       m.disabled=false;
                    }
                });
                this.isPercentage=false;
                this.isConstant=false;
                this.howLongAlertCreateName="报警间隔时间:";
            }else if("亮度报警"){
                this.mTypeData.forEach(m=>{
                    if(m.mtypeName!="亮度"){
                        m.disabled=true;
                    }else{
                       m.disabled=false;
                    }
                });
                this.isPercentage=true;
                this.isConstant=false;
                this.howLongAlertCreateName="连续预警几次生成报警：";
            }
             

        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            this.isLabel=true;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "报警配置信息";
            if (Hrrtype != "add") {
                this.form = row;
                this.$route.meta.row = null;
            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
                this.isLabel=false;
                if(row!=undefined && row!=""){
                    this.isElectricAlert=row.alertName!="离线报警"&&row.alertName!="上线报警"?true:false;
                    this.isNoElectricAlert=row.alertName=="离线报警"||row.alertName=="上线报警"?true:false;
                }
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                if(row!=undefined && row!=""){
                    this.isElectricAlert=row.alertName!="离线报警"&&row.alertName!="上线报警"?true:false;
                    this.isNoElectricAlert=row.alertName=="离线报警"||row.alertName=="上线报警"?true:false;
                }
                this.isEdit = true;
            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
            var myVuethis = this;
            //所属地铁站
            this.$hrraxios.get(this.$api.site.downlist)
                .then((response) => {
                    var data = response.data;
                    if (data.Success == true) {
                        myVuethis.siteidData = data.Data;
                    } else {
                        myVuethis.$message.error("数据初始化失败,请联系管理员");
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
        },
        initParamsData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.AlertConfig.downlistmtype)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.mTypeData = data.Data;
                        Vuethis.initAlertName(Vuethis.form.alertName);
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        inputFnc: function() {
            this.form.howLongAlertCreate = this.form.howLongAlertCreate != null && this.form.howLongAlertCreate != "" ? parseFloat((this.form.howLongAlertCreate).toFixed(0)) : 0;
            this.form.oneDayHowNumSend = this.form.oneDayHowNumSend != null && this.form.oneDayHowNumSend != "" ? parseFloat((this.form.oneDayHowNumSend).toFixed(0)) : 0;
            this.form.howLongWithoutData = this.form.howLongWithoutData != null && this.form.howLongWithoutData != "" ? parseFloat((this.form.howLongWithoutData).toFixed(0)) : 0;
            this.form.howLongHaveData = this.form.howLongHaveData != null && this.form.howLongHaveData != "" ? parseFloat((this.form.howLongHaveData).toFixed(0)) : 0;
        },
    },
 
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.returnPath = from.path;
        })
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.initData();
        this.initParamsData();
    }
}
</script>
<style>
.el-form-module-config {
    width: 530px;
}

span.level1 {
    padding-left: 0;
}

span.level2 {
    padding-left: 12px;
}

span.level3 {
    padding-left: 24px;
}

span.level4 {
    padding-left: 36px;
}
</style>